import React from "react";

export const SectionLabel = ({ children, c }) => (
  <div style={{
    display: "inline-block",
    padding: "4px 16px", borderRadius: 9999,
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 12, letterSpacing: "0.2em",
    color: c.primary, textTransform: "uppercase",
    background: `${c.primary}18`,
    border: `1px solid ${c.primary}30`,
    marginBottom: 24,
  }}>
    {children}
  </div>
);